"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PersonalRegisterContainer = void 0;
var _CallAPI = require("01_core/components/system/CallAPI");
var _APIs = require("01_core/constants/APIs");
var _coreInfoBarActions = require("01_core/reducers/coreInfoBarActions");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _PersonalRegisterEntry = _interopRequireDefault(require("./PersonalRegisterEntry"));
var _PersonalRegisterResult = _interopRequireDefault(require("./PersonalRegisterResult"));
var _personalRegisterActions = require("./personalRegisterActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * 個人情報設定
 */
class PersonalRegisterContainer extends _react.default.Component {
  constructor(props) {
    super(props);

    // データ取得処理
    props.callAPI(_APIs.PERSONAL_INFO_SEARCH).then(response => {
      const {
        openInfoBar,
        setEntries
      } = this.props;
      if (response.status !== _APIs.STATUS.SUCCESS) {
        openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, response.message);
        return;
      }
      const data = _objectSpread({}, response.data);
      // 拠点トグルの初期値を設定
      if (data.workRenkeiFlg || data.masterFlg) {
        // 人事連携済み または、マスタ情報登録済みなら、トグル自体非表示
        data.siteListProp = null;
      } else if (data.siteOtherNm) {
        // 都道府県コード（その他）が設定されていれば、リストにない拠点を入力
        data.siteListProp = _personalRegisterActions.SITE_LIST_PROP_CODE.INPUT_LIST;
      } else {
        // それ以外の場合、リストから探す
        data.siteListProp = _personalRegisterActions.SITE_LIST_PROP_CODE.LIST_SEARCH;
      }
      setEntries(data);
    });
  }
  componentWillUnmount() {
    this.props.clear();
  }
  render() {
    const {
      dispContent,
      onBack
    } = this.props;
    if (dispContent === _personalRegisterActions.CONTENTS.ENTER) {
      return /*#__PURE__*/_react.default.createElement(_PersonalRegisterEntry.default, {
        onBack: onBack
      });
    }
    if (dispContent === _personalRegisterActions.CONTENTS.RESULT) {
      return /*#__PURE__*/_react.default.createElement(_PersonalRegisterResult.default, {
        onBack: onBack
      });
    }
  }
}
exports.PersonalRegisterContainer = PersonalRegisterContainer;
PersonalRegisterContainer.propTypes = {
  // Parent
  onBack: _propTypes.default.func,
  // withCallAPI
  callAPI: _propTypes.default.func,
  // State
  dispContent: _propTypes.default.string,
  // Dispatch
  openInfoBar: _propTypes.default.func,
  setEntries: _propTypes.default.func,
  clear: _propTypes.default.func
};
const mapStateToProps = state => {
  return {
    dispContent: state.personalRegister.dispContent
  };
};
const mapDispatchToProps = dispatch => {
  return {
    openInfoBar: (type, message) => dispatch(_coreInfoBarActions.coreInfoBarActions[_coreInfoBarActions.TYPES_INFO_BAR.OPEN](type, message)),
    setEntries: entries => dispatch(_personalRegisterActions.personalRegisterActions[_personalRegisterActions.TYPES.SET_ENTRIES](entries)),
    clear: () => dispatch(_personalRegisterActions.personalRegisterActions[_personalRegisterActions.TYPES.CLEAR]())
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _CallAPI.withCallAPI)(PersonalRegisterContainer));